import type {
  TrackingPageOrder,
  TrackingPageShipment,
} from "@redotech/order-tracking-common/tracking-page-order-definition";

// POS orders are typically in-store purchases with nothing to ship, so the
// tracking-details block is hidden for them. But a POS order can still be
// fulfilled with a real shipment (carrier + tracking number), in which case
// the customer expects to track it — don't hide the block in that case.
export function shouldHidePosTrackingDetails(
  order: Pick<TrackingPageOrder, "sourceName">,
  shipment:
    | Pick<TrackingPageShipment, "trackingCode" | "trackingEvents">
    | undefined,
): boolean {
  if (order.sourceName !== "pos") {
    return false;
  }
  const hasTrackableShipment =
    !!shipment?.trackingCode || !!shipment?.trackingEvents?.length;
  return !hasTrackableShipment;
}
